import script from "./acquiredAssets.vue?vue&type=script&setup=true&lang=js"
export * from "./acquiredAssets.vue?vue&type=script&setup=true&lang=js"

import "./acquiredAssets.vue?vue&type=style&index=0&id=54955e1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54955e1e"]])

export default __exports__